// tslint:disable

import * as React from 'react';
import {get} from 'lodash';
import {InputField} from '../../components/fields/input.field';
import {FormLib} from '../../components/libs/form.lib';
import {ResourceLoader} from '../../components/libs/resource-loader';
import {DefaultSave} from '../../components/libs/updaters/default-save';
import {Validators} from '../../components/libs/Validators';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {ToggleBoxComponent} from '../../components/structurals/toggle-box.component';
import {DatepickerField} from "../../components/fields/datepicker.field";
import {TextAreaField} from "../../components/fields/textarea.field";
import {IriField} from "../../components/fields/iri.field";
import {MediaItemField} from "../../components/fields/media-item.field";
import {ResourceModal} from "../../components/structurals/resource-modal";
import {ListLib} from "../../components/libs/list.lib";


export class DefaultEventAgenda extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {

        form.fields.event.registerField();
        form.fields.event.setValue(this.props.CONFIG.event);

        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="event-agenda" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create new event agenda' : 'Edit event agenda'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <div className="row">
                    <div className="col-sm-9">
                        <ToggleBoxComponent title="Event period details" color="green" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <InputField
                                        field={form.fields.title}
                                        validators={[
                                            Validators.required('Required')
                                        ]}/>

                                    <InputField
                                        field={form.fields.place}
                                    />

                                    <TextAreaField
                                        field={form.fields.description}
                                        validators={[Validators.required('Required')]}/>

                                    <DatepickerField field={form.fields.startDate}/>

                                    <DatepickerField field={form.fields.endDate}/>

                                    <IriField
                                        field={form.fields.speaker}
                                        defaultAll={true}
                                        itemRender={(item: any) => get(item, 'name')}
                                    />

                                    {/*<ResourceModal entity={'article-tag'} entityId={'create'} extClass={'btn-xs'} title={<div><i className="fa fa-plus"/> Add new Tag</div>}/>*/}


                                    <ResourceModal
                                        entity="agenda-speaker"
                                        entityId="create"
                                        extClass="btn-xs"
                                        config={{agenda: `/event-agenda/${this.props.ENTITY_ID}`}}
                                        title={<div><i className="fa fa-plus"/> Add new speaker</div>}/>

                                    <button className="btn btn-success pull-left" onClick={() => this.saveForm(form)}>Save</button>
                                </div>
                            </div>
                        </ToggleBoxComponent>
                    </div>
                    <div className="col-sm-3">
                        <ToggleBoxComponent title="Media" alwaysOpen={true}>
                            <MediaItemField
                                field={form.fields.logo}
                            />
                        </ToggleBoxComponent>
                    </div>
                </div>

            </div>}/>
        );
    }

    handleCreateAndUpdate(pc: any, list: ListLib) {
        list.refetch();
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.event-agenda.tsx